import { jsx as _jsx } from "react/jsx-runtime";
export default function ArrowUpIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "arcs",
    children: /*#__PURE__*/_jsx("path", {
      d: "M18 15l-6-6-6 6"
    })
  });
}